import React from 'react';

import {ListboxGroup} from '@pb/kit-component-listbox';

import type {ListboxGroupProps} from '@pb/kit-component-listbox';

/**
 * Thin wrapper around `<ListboxGroup>` that groups `<ComboboxItem>` elements
 * under a titled heading inside the `<ComboBox>` listbox.
 *
 * @see [Storybook]{@link https://storybook.dev.pitchbookdata.com/?path=/docs/forms-combo-box}
 */
export const ComboboxGroup = (props: ListboxGroupProps) => {
    return <ListboxGroup {...props}/>;
};

ComboboxGroup.displayName = 'ComboboxGroup';
